export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `AWSDate` scalar type provided by AWS AppSync, represents a valid ***extended*** [ISO 8601 Date](https://en.wikipedia.org/wiki/ISO_8601#Calendar_dates) string. In other words, this scalar type accepts date strings of the form `YYYY-MM-DD`.  The scalar can also accept "negative years" of the form `-YYYY` which correspond to years before `0000`. For example, "**-2017-05-01**" and "**-9999-01-01**" are both valid dates.  This scalar type can also accept an optional [time zone offset](https://en.wikipedia.org/wiki/ISO_8601#Time_zone_designators). For example, "**1970-01-01**", "**1970-01-01Z**", "**1970-01-01-07:00**" and "**1970-01-01+05:30**" are all valid dates. The time zone offset must either be `Z` (representing the UTC time zone) or be in the format `±hh:mm:ss`. The seconds field in the timezone offset will be considered valid even though it is not part of the ISO 8601 standard. */
  AWSDate: { input: string; output: string; }
  /** The `AWSDateTime` scalar type provided by AWS AppSync, represents a valid ***extended*** [ISO 8601 DateTime](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) string. In other words, this scalar type accepts datetime strings of the form `YYYY-MM-DDThh:mm:ss.SSSZ`.  The scalar can also accept "negative years" of the form `-YYYY` which correspond to years before `0000`. For example, "**-2017-01-01T00:00Z**" and "**-9999-01-01T00:00Z**" are both valid datetime strings.  The field after the two digit seconds field is a nanoseconds field. It can accept between 1 and 9 digits. So, for example, "**1970-01-01T12:00:00.2Z**", "**1970-01-01T12:00:00.277Z**" and "**1970-01-01T12:00:00.123456789Z**" are all valid datetime strings.  The seconds and nanoseconds fields are optional (the seconds field must be specified if the nanoseconds field is to be used).  The [time zone offset](https://en.wikipedia.org/wiki/ISO_8601#Time_zone_designators) is compulsory for this scalar. The time zone offset must either be `Z` (representing the UTC time zone) or be in the format `±hh:mm:ss`. The seconds field in the timezone offset will be considered valid even though it is not part of the ISO 8601 standard. */
  AWSDateTime: { input: string; output: string; }
  /** The `AWSEmail` scalar type provided by AWS AppSync, represents an Email address string that complies with [RFC 822](https://www.ietf.org/rfc/rfc822.txt). For example, "**username@example.com**" is a valid Email address. */
  AWSEmail: { input: string; output: string; }
  AWSIPAddress: { input: string; output: string; }
  AWSJSON: { input: string; output: string; }
  AWSPhone: { input: string; output: string; }
  /** The `AWSTime` scalar type provided by AWS AppSync, represents a valid ***extended*** [ISO 8601 Time](https://en.wikipedia.org/wiki/ISO_8601#Times) string. In other words, this scalar type accepts time strings of the form `hh:mm:ss.SSS`.  The field after the two digit seconds field is a nanoseconds field. It can accept between 1 and 9 digits. So, for example, "**12:00:00.2**", "**12:00:00.277**" and "**12:00:00.123456789**" are all valid time strings. The seconds and nanoseconds fields are optional (the seconds field must be specified if the nanoseconds field is to be used).  This scalar type can also accept an optional [time zone offset](https://en.wikipedia.org/wiki/ISO_8601#Time_zone_designators). For example, "**12:30**", "**12:30Z**", "**12:30:24-07:00**" and "**12:30:24.500+05:30**" are all valid time strings. The time zone offset must either be `Z` (representing the UTC time zone) or be in the format `±hh:mm:ss`. The seconds field in the timezone offset will be considered valid even though it is not part of the ISO 8601 standard. */
  AWSTime: { input: string; output: string; }
  AWSTimestamp: { input: number; output: number; }
  AWSURL: { input: string; output: string; }
  /** Long type */
  Long: { input: number; output: number; }
};

export type AcceptTermsAndCondition = {
  __typename?: 'AcceptTermsAndCondition';
  acceptedAt: Scalars['AWSDateTime']['output'];
  customerId: Scalars['ID']['output'];
  version: Scalars['String']['output'];
};

export type AssignedMachineInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AssignedMachineType = {
  __typename?: 'AssignedMachineType';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum AsyncJobStatus {
  Created = 'CREATED',
  Done = 'DONE',
  Processing = 'PROCESSING'
}

export type Attachment = {
  __typename?: 'Attachment';
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

export type AttachmentNameCheck = {
  __typename?: 'AttachmentNameCheck';
  exists: Scalars['Boolean']['output'];
};

export type AttachmentUploadLinkData = {
  __typename?: 'AttachmentUploadLinkData';
  fields: Array<Field>;
  url: Scalars['String']['output'];
};

export enum BatteryDischargeStatus {
  Critical = 'CRITICAL',
  NoData = 'NO_DATA',
  Ok = 'OK',
  Warning = 'WARNING'
}

export type BatteryDischargeStatusCount = {
  __typename?: 'BatteryDischargeStatusCount';
  count: Scalars['Int']['output'];
  status: BatteryDischargeStatus;
};

export type CleanedAreaSummary = {
  __typename?: 'CleanedAreaSummary';
  periodCleanedArea: Scalars['Int']['output'];
  totalCleanedArea: Scalars['Int']['output'];
};

export type CleanedHrsSummary = {
  __typename?: 'CleanedHrsSummary';
  periodCleanedHrs: Scalars['Float']['output'];
  totalCleanedHrs: Scalars['Float']['output'];
};

export type CleaningReportSubscription = {
  __typename?: 'CleaningReportSubscription';
  formats: Array<CleaningReportSubscriptionReportFormat>;
  interval: CleaningReportSubscriptionInterval;
  timezone?: Maybe<Scalars['String']['output']>;
  type: CleaningReportSubscriptionType;
};

export enum CleaningReportSubscriptionInterval {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum CleaningReportSubscriptionReportFormat {
  Excel = 'EXCEL',
  Pdf = 'PDF'
}

export enum CleaningReportSubscriptionType {
  Events = 'EVENTS',
  Robot = 'ROBOT',
  Total = 'TOTAL'
}

export type CleaningReportsExportRequestOutput = {
  __typename?: 'CleaningReportsExportRequestOutput';
  requestId: Scalars['String']['output'];
};

export type CleaningRoutine = {
  __typename?: 'CleaningRoutine';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  currentRepeat: Scalars['Int']['output'];
  customerId: Scalars['String']['output'];
  endDate?: Maybe<Scalars['AWSDateTime']['output']>;
  estimatedEndDate?: Maybe<Scalars['AWSDateTime']['output']>;
  executionId: Scalars['String']['output'];
  machineId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numberOfRepeats: Scalars['Int']['output'];
  routineCompletion?: Maybe<RoutineCompletion>;
  routineId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['AWSDateTime']['output']>;
  status?: Maybe<RoutineStatus>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type CleaningTaskCleanedAreaByDay = {
  __typename?: 'CleaningTaskCleanedAreaByDay';
  cleanedArea: Scalars['Int']['output'];
  finishedAt: Scalars['AWSDateTime']['output'];
};

export type CleaningTaskCleanedAreaByDayList = {
  __typename?: 'CleaningTaskCleanedAreaByDayList';
  cleanedAreaList?: Maybe<Array<CleaningTaskCleanedAreaByDay>>;
  cleanedAreaSummary: CleanedAreaSummary;
};

export type CleaningTaskCleanedHrsByDay = {
  __typename?: 'CleaningTaskCleanedHrsByDay';
  cleanedHrs: Scalars['Float']['output'];
  date: Scalars['AWSDateTime']['output'];
};

export type CleaningTaskCleanedHrsByDayList = {
  __typename?: 'CleaningTaskCleanedHrsByDayList';
  cleanedHrsList?: Maybe<Array<CleaningTaskCleanedHrsByDay>>;
  cleanedHrsSummary: CleanedHrsSummary;
};

export type CleaningTaskConsumablesByDay = {
  __typename?: 'CleaningTaskConsumablesByDay';
  consumptions: RobotCleaningConsumption;
  finishedAt: Scalars['AWSDateTime']['output'];
};

export type CleaningTaskConsumablesByDayList = {
  __typename?: 'CleaningTaskConsumablesByDayList';
  consumablesList?: Maybe<Array<CleaningTaskConsumablesByDay>>;
  consumablesSummary: ConsumablesSummary;
};

export type CleaningTaskDistanceDrivenByDay = {
  __typename?: 'CleaningTaskDistanceDrivenByDay';
  distanceDriven: Scalars['Float']['output'];
  finishedAt: Scalars['AWSDateTime']['output'];
};

export type CleaningTaskDistanceDrivenByDayList = {
  __typename?: 'CleaningTaskDistanceDrivenByDayList';
  distanceDrivenList?: Maybe<Array<CleaningTaskDistanceDrivenByDay>>;
  distanceDrivenSummary: DistanceDrivenSummary;
};

export type CleaningTaskReport = {
  __typename?: 'CleaningTaskReport';
  actualOperatingTimeInSeconds: Scalars['Int']['output'];
  battery?: Maybe<Scalars['Float']['output']>;
  classification: MachineClassification;
  cleanedSquareMeter?: Maybe<Scalars['Int']['output']>;
  currentRepeat?: Maybe<Scalars['Int']['output']>;
  customerId: Scalars['String']['output'];
  detergents?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  executionId?: Maybe<Scalars['String']['output']>;
  finishedAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  machine: Machine;
  machineName?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  materialNumber: Scalars['String']['output'];
  pathCoverage?: Maybe<Scalars['Float']['output']>;
  repeatPathId?: Maybe<Scalars['String']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
  routineName?: Maybe<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
  startedAt: Scalars['AWSDateTime']['output'];
  taskCompletion?: Maybe<Scalars['String']['output']>;
  totalRepeats?: Maybe<Scalars['Int']['output']>;
  water?: Maybe<Scalars['Float']['output']>;
};

export enum Column {
  Accuracy = 'ACCURACY',
  ActivationDate = 'ACTIVATION_DATE',
  Address = 'ADDRESS',
  AvgWorkingTimePerDay = 'AVG_WORKING_TIME_PER_DAY',
  BatteryDischargeStatus = 'BATTERY_DISCHARGE_STATUS',
  Category = 'CATEGORY',
  Classification = 'CLASSIFICATION',
  CleaningDays = 'CLEANING_DAYS',
  DataStatus = 'DATA_STATUS',
  Deviation = 'DEVIATION',
  FinanceContractNumber = 'FINANCE_CONTRACT_NUMBER',
  FinanceContractType = 'FINANCE_CONTRACT_TYPE',
  FullfillmentInPercentage = 'FULLFILLMENT_IN_PERCENTAGE',
  GeofenceStatus = 'GEOFENCE_STATUS',
  InventoryNumber = 'INVENTORY_NUMBER',
  LastConnection = 'LAST_CONNECTION',
  MachineName = 'MACHINE_NAME',
  MachineType = 'MACHINE_TYPE',
  MaterialNumber = 'MATERIAL_NUMBER',
  OperatingHours = 'OPERATING_HOURS',
  PlannedOperatingHours = 'PLANNED_OPERATING_HOURS',
  PlannedShifts = 'PLANNED_SHIFTS',
  SerialNumber = 'SERIAL_NUMBER',
  ServiceAgreementType = 'SERVICE_AGREEMENT_TYPE',
  SiteManagers = 'SITE_MANAGERS',
  SiteName = 'SITE_NAME',
  SumMissedCleaningJobs = 'SUM_MISSED_CLEANING_JOBS',
  TotalOperatingHours = 'TOTAL_OPERATING_HOURS'
}

export type ConsumablesSummary = {
  __typename?: 'ConsumablesSummary';
  periodBattery: Scalars['Float']['output'];
  periodDetergents: Scalars['Float']['output'];
  periodWater: Scalars['Float']['output'];
};

export type Coordinate = {
  __typename?: 'Coordinate';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export enum DataStatus {
  GreaterThanThreeDaysOld = 'GREATER_THAN_THREE_DAYS_OLD',
  LessThanOneDayOld = 'LESS_THAN_ONE_DAY_OLD',
  NoData = 'NO_DATA',
  OneToThreeDaysOld = 'ONE_TO_THREE_DAYS_OLD'
}

export type DataStatusCount = {
  __typename?: 'DataStatusCount';
  count: Scalars['Int']['output'];
  status: DataStatus;
};

export type DistanceDrivenSummary = {
  __typename?: 'DistanceDrivenSummary';
  periodDistanceDriven: Scalars['Float']['output'];
  totalDistanceDriven: Scalars['Float']['output'];
};

export type Field = {
  __typename?: 'Field';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FilterActivatedAt = {
  from: Scalars['AWSDateTime']['input'];
  to: Scalars['AWSDateTime']['input'];
};

export type FilterLastActivityAt = {
  from: Scalars['AWSDateTime']['input'];
  to: Scalars['AWSDateTime']['input'];
};

export type Finance = {
  __typename?: 'Finance';
  contractNumber?: Maybe<Scalars['String']['output']>;
  financeType?: Maybe<FinanceType>;
};

export enum FinanceType {
  HirePurchase = 'HIRE_PURCHASE',
  Leasing = 'LEASING',
  Purchase = 'PURCHASE',
  Rental = 'RENTAL'
}

export type FleetOperatingTime = {
  __typename?: 'FleetOperatingTime';
  actualTotalOperatingTimeS: Scalars['Long']['output'];
  plannedTotalOperatingTimeS: Scalars['Long']['output'];
};

export type GeofenceStatusCount = {
  __typename?: 'GeofenceStatusCount';
  count: Scalars['Int']['output'];
  status: GeofenceStatusType;
};

export enum GeofenceStatusType {
  Inside = 'INSIDE',
  NoData = 'NO_DATA',
  Outside = 'OUTSIDE'
}

export type GetExportFileOutput = {
  __typename?: 'GetExportFileOutput';
  objectKey?: Maybe<Scalars['String']['output']>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
  status: AsyncJobStatus;
};

export type GetExportOutput = {
  __typename?: 'GetExportOutput';
  requestId: Scalars['String']['output'];
  status: AsyncJobStatus;
};

export type InputAcceptTermsAndCondition = {
  contractObligationVersion: Scalars['String']['input'];
  licenseAgreementVersion: Scalars['String']['input'];
};

export type InputCircle = {
  centerPoint: InputCoordinate;
  radius: Scalars['Float']['input'];
};

export type InputCleaningReportSubscription = {
  formats: Array<CleaningReportSubscriptionReportFormat>;
  interval: CleaningReportSubscriptionInterval;
  type: CleaningReportSubscriptionType;
};

export type InputCoordinate = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type InputFilterCleaningConsumption = {
  machineIds?: InputMaybe<Array<Scalars['String']['input']>>;
  machines?: InputMaybe<InputMachineFilter>;
  period: InputPeriod;
  routeName?: InputMaybe<Scalars['String']['input']>;
  taskCompletions?: InputMaybe<Array<TaskCompletion>>;
};

export type InputFilterCleaningReportsExportRequest = {
  machineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  period: InputPeriod;
  reportType: ReportType;
};

export type InputFilterCleaningTaskCleanedAreaByDayList = {
  machineId: Scalars['String']['input'];
  period: InputPeriod;
  routeName?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterCleaningTaskCleanedHrsByDayList = {
  machineId: Scalars['String']['input'];
  period: InputPeriod;
  routeName?: InputMaybe<Scalars['String']['input']>;
  timeZone: Scalars['String']['input'];
};

export type InputFilterCleaningTaskConsumablesByDayList = {
  machineId: Scalars['String']['input'];
  period: InputPeriod;
  routeName?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterCleaningTaskDistanceDrivenByDayList = {
  machineId: Scalars['String']['input'];
  period: InputPeriod;
  routeName?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterCleaningTaskReportsList = {
  machineIds?: InputMaybe<Array<Scalars['String']['input']>>;
  machines?: InputMaybe<InputMachineFilter>;
  period: InputPeriod;
  routeName?: InputMaybe<Scalars['String']['input']>;
  taskCompletions?: InputMaybe<Array<TaskCompletion>>;
};

export type InputFilterFleetOperatingTime = {
  period: InputPeriod;
};

export type InputFilterMachineIdsList = {
  machineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  siteId?: InputMaybe<Scalars['ID']['input']>;
};

export type InputFilterMachinesList = {
  classifications?: InputMaybe<Array<MachineClassification>>;
  connectionStatuses?: InputMaybe<Array<MachineConnectionStatus>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isIoTDevice?: InputMaybe<Scalars['Boolean']['input']>;
  isRobotStatusEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isStandalone?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<FilterLastActivityAt>;
  materialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  robotStatuses?: InputMaybe<Array<RobotStatus>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type InputFilterMachinesReport = {
  activatedAt?: InputMaybe<FilterActivatedAt>;
  batteryDischargeStatuses?: InputMaybe<Array<BatteryDischargeStatus>>;
  classifications?: InputMaybe<Array<MachineClassification>>;
  connectionStatuses?: InputMaybe<Array<MachineConnectionStatus>>;
  dataStatuses?: InputMaybe<Array<DataStatus>>;
  financeTypes?: InputMaybe<Array<FinanceType>>;
  geofenceStatuses?: InputMaybe<Array<MachineGeofenceStatus>>;
  isIoTDevice?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<FilterLastActivityAt>;
  machineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  materialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  servicePackages?: InputMaybe<Array<ServicePackage>>;
  siteIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  softwareVersion?: InputMaybe<Scalars['String']['input']>;
  subclassifications?: InputMaybe<Array<MachineSubclassification>>;
  utilizations?: InputMaybe<Array<MachineUtilization>>;
};

export type InputFilterManualMachineDashboard = {
  machineIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  siteIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type InputFilterNotificationsList = {
  categories?: InputMaybe<Array<NotificationCategory>>;
  machineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  period?: InputMaybe<InputPeriod>;
  severities?: InputMaybe<Array<Severity>>;
  type?: InputMaybe<Type>;
};

export type InputFilterRobotCleaningRoutesList = {
  machineId: Scalars['String']['input'];
  period: InputPeriod;
};

export type InputFilterRobotDashboardKpIsGet = {
  executionId?: InputMaybe<Scalars['String']['input']>;
  machineIds?: InputMaybe<Array<Scalars['String']['input']>>;
  machines?: InputMaybe<InputMachineFilter>;
  period?: InputMaybe<InputPeriod>;
  routeName?: InputMaybe<Scalars['String']['input']>;
  taskCompletions?: InputMaybe<Array<TaskCompletion>>;
};

export type InputFilterRobotDashboardTotalCleanedAreaGet = {
  machineIds?: InputMaybe<Array<Scalars['String']['input']>>;
  period: InputPeriod;
  routeName?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterRobotDashboardTotalCleanedHrsGet = {
  machineIds?: InputMaybe<Array<Scalars['String']['input']>>;
  period: InputPeriod;
  routeName?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterRobotTaskCompletionStatisticGet = {
  machineIds?: InputMaybe<Array<Scalars['String']['input']>>;
  period: InputPeriod;
  routeName?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterRoutineCleaningTaskReport = {
  executionId: Scalars['String']['input'];
};

export type InputFilterSingleRoutesAndRoutinesList = {
  machineIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  period: InputPeriod;
  siteNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taskCompletions?: InputMaybe<Array<InputMaybe<TaskCompletion>>>;
};

export type InputFilterSiteAddressCoordinateGet = {
  text: Scalars['String']['input'];
};

export type InputFilterSiteAddressesSuggestionList = {
  text: Scalars['String']['input'];
};

export type InputFilterSiteCleaningStatistic = {
  classifications: Array<MachineClassification>;
  connectionStatuses?: InputMaybe<Array<MachineConnectionStatus>>;
  machineIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  period: InputPeriod;
  robotStatuses?: InputMaybe<Array<RobotStatus>>;
};

export type InputFilterSiteMachinesList = {
  classifications?: InputMaybe<Array<MachineClassification>>;
  connectionStatuses?: InputMaybe<Array<MachineConnectionStatus>>;
  isRobotStatusEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  robotStatuses?: InputMaybe<Array<RobotStatus>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterSitesList = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputFilterTagsItemsGet = {
  itemType: ItemType;
  tags: Array<Scalars['String']['input']>;
};

export type InputFilterTagsList = {
  textBegin?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterUsersList = {
  role?: InputMaybe<Role>;
  status?: InputMaybe<Status>;
};

export type InputFilterWorkIntervalsList = {
  siteId: Scalars['ID']['input'];
};

export type InputFinance = {
  contractNumber?: InputMaybe<Scalars['String']['input']>;
  financeType?: InputMaybe<FinanceType>;
};

export type InputListPlannedAndActualForPeriod = {
  machineId: Scalars['String']['input'];
  period: InputPeriod;
};

export type InputMachineFilter = {
  classifications?: InputMaybe<Array<MachineClassification>>;
};

export type InputMachineFilterFilter = {
  batteryDischargeStatuses?: InputMaybe<Array<BatteryDischargeStatus>>;
  classifications?: InputMaybe<Array<MachineClassification>>;
  dataStatuses?: InputMaybe<Array<DataStatus>>;
  financeTypes?: InputMaybe<Array<FinanceType>>;
  geofenceStatuses?: InputMaybe<Array<MachineGeofenceStatus>>;
  materialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  servicePackages?: InputMaybe<Array<ServicePackage>>;
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  subclassifications?: InputMaybe<Array<MachineSubclassification>>;
  utilizations?: InputMaybe<Array<MachineUtilization>>;
};

export type InputMachineNoteCreate = {
  description: Scalars['String']['input'];
  machineId: Scalars['String']['input'];
};

export type InputMachineNoteUpdate = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  machineId: Scalars['String']['input'];
};

export type InputMachineUpdate = {
  finance?: InputMaybe<InputFinance>;
  inventoryNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  servicePackage?: InputMaybe<ServicePackage>;
  siteId?: InputMaybe<Scalars['ID']['input']>;
};

export type InputMachinesReportSubscription = {
  lang: SupportedLanguage;
  reportFileFormats: Array<MachinesReportSubscriptionReportFileFormat>;
  reportInterval: MachinesReportSubscriptionReportInterval;
  reportType: MachinesReportSubscriptionReportType;
};

export type InputNoteCreator = {
  displayName: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type InputNotificationUpdateNotifyStatus = {
  assignedMachines: Array<InputMaybe<AssignedMachineInput>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  emailSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  notifyAutonomousTaskStopped: Scalars['Boolean']['input'];
  notifyBatteryDeepDischarge: Scalars['Boolean']['input'];
  notifyCleaningTaskFinished: Scalars['Boolean']['input'];
  notifyCleaningTaskInterrupted: Scalars['Boolean']['input'];
  notifyEmergencyStop: Scalars['Boolean']['input'];
  notifyErrorOccurred: Scalars['Boolean']['input'];
  notifyInformation: Scalars['Boolean']['input'];
  notifyLocationStatus: Scalars['Boolean']['input'];
  notifyNoWorkStart: Scalars['Boolean']['input'];
  notifyOther: Scalars['Boolean']['input'];
  notifyPCM: Scalars['Boolean']['input'];
  notifyReminder: Scalars['Boolean']['input'];
  notifyResources: Scalars['Boolean']['input'];
  notifyServiceNeeded: Scalars['Boolean']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type InputNotificationUpsertOperator = {
  assignedMachines: Array<AssignedMachineInput>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notifications?: InputMaybe<InputOperatorNotificationUpdateNotifyStatus>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type InputOperatorNotificationUpdateNotifyStatus = {
  notifyAutonomousTaskStopped: Scalars['Boolean']['input'];
  notifyBatteryDeepDischarge: Scalars['Boolean']['input'];
  notifyCleaningTaskFinished: Scalars['Boolean']['input'];
  notifyCleaningTaskInterrupted: Scalars['Boolean']['input'];
  notifyEmergencyStop: Scalars['Boolean']['input'];
  notifyErrorOccurred: Scalars['Boolean']['input'];
  notifyInformation: Scalars['Boolean']['input'];
  notifyLocationStatus: Scalars['Boolean']['input'];
  notifyNoWorkStart: Scalars['Boolean']['input'];
  notifyOther: Scalars['Boolean']['input'];
  notifyPCM: Scalars['Boolean']['input'];
  notifyReminder: Scalars['Boolean']['input'];
  notifyResources: Scalars['Boolean']['input'];
  notifyServiceNeeded: Scalars['Boolean']['input'];
};

export type InputPagingOptions = {
  limit: Scalars['Int']['input'];
  paginationToken?: InputMaybe<Scalars['String']['input']>;
};

export type InputPeriod = {
  endAt: Scalars['AWSDateTime']['input'];
  startAt: Scalars['AWSDateTime']['input'];
};

export type InputReminderCreate = {
  description: Scalars['String']['input'];
  localRepetitiveDate: Scalars['AWSDate']['input'];
  localRepetitiveTime: Scalars['AWSTime']['input'];
  machineId: Scalars['String']['input'];
  repetition: RepetitionInterval;
  startAt: Scalars['AWSDateTime']['input'];
  timezone: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};

export type InputSiteAddressesSuggestionListPagingOptions = {
  limit: Scalars['Int']['input'];
};

export type InputSiteAssignMachine = {
  machineIds: Array<InputMaybe<Scalars['ID']['input']>>;
  siteId: Scalars['ID']['input'];
};

export type InputSiteAssignManagers = {
  siteId: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputSiteCreate = {
  location?: InputMaybe<InputSiteLocation>;
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputSiteGeofenceSetup = {
  circle: InputCircle;
};

export type InputSiteLocation = {
  address?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type InputSiteTagAdd = {
  tag: Scalars['String']['input'];
};

export type InputSiteTagRemove = {
  tag: Scalars['String']['input'];
};

export type InputSiteTagsOverride = {
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputSiteUnassignMachine = {
  machineId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type InputSiteUnassignManager = {
  siteId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type InputSiteUpdate = {
  location?: InputMaybe<InputSiteLocation>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputSortOptions = {
  field: Scalars['String']['input'];
  order: SortOrders;
};

export type InputUserDeleteByEmail = {
  email: Scalars['String']['input'];
};

export type InputUserInvite = {
  assignedSiteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  role: Role;
  salutation?: InputMaybe<Scalars['String']['input']>;
};

export type InputUserUpdate = {
  role: Role;
};

export type InputWorkIntervalCreate = {
  createdAt: Scalars['AWSDateTime']['input'];
  durationMs: Scalars['Int']['input'];
  machineId: Scalars['String']['input'];
  plannedDurationMs?: InputMaybe<Scalars['Int']['input']>;
  recurring: RecurrenceInterval;
  startHoursUtc: Scalars['Int']['input'];
  startMinutesUtc: Scalars['Int']['input'];
  weekdaysUtc: Array<Scalars['Int']['input']>;
};

export type InputWorkIntervalUpdate = {
  machineId?: InputMaybe<Scalars['String']['input']>;
  timeSpan?: InputMaybe<TimeSpan>;
  weekdaysUtc?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum ItemType {
  General = 'GENERAL'
}

export type Location = {
  __typename?: 'Location';
  accuracy: Scalars['Float']['output'];
  address?: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type Machine = {
  __typename?: 'Machine';
  activationDate: Scalars['AWSDateTime']['output'];
  attachments?: Maybe<ResponseMachineAttachmentsList>;
  batteryDischargeStatus?: Maybe<MachineBatteryDischargeStatus>;
  classification?: Maybe<MachineClassification>;
  cleaningTaskReportLatestGet?: Maybe<ResponseLatestCleaningTaskReport>;
  connectionStatus: MachineConnectionStatus;
  customerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isIoTDevice?: Maybe<Scalars['Boolean']['output']>;
  lastActivityAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastConnectedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  latestRoutine?: Maybe<ResponseLatestRoutine>;
  location?: Maybe<Location>;
  materialNumber: Scalars['String']['output'];
  metadata?: Maybe<MachineMetadata>;
  name: Scalars['String']['output'];
  notes?: Maybe<ResponseMachineNotesList>;
  operatingTimeForPeriod?: Maybe<OperatingTimePeriod>;
  reminders?: Maybe<ResponseRemindersList>;
  robotStatus?: Maybe<RobotStatus>;
  serialNumber: Scalars['String']['output'];
  site?: Maybe<Site>;
  softwareVersion?: Maybe<Scalars['String']['output']>;
  states?: Maybe<Array<State>>;
  totalOperatingTime?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<MachineType>;
  variant: MachineVariant;
};


export type MachineAttachmentsArgs = {
  paginationOptions: InputPagingOptions;
  sortOptions?: InputMaybe<InputSortOptions>;
};


export type MachineNotesArgs = {
  paginationOptions: InputPagingOptions;
};


export type MachineOperatingTimeForPeriodArgs = {
  period: InputPeriod;
};


export type MachineRemindersArgs = {
  paginationOptions: InputPagingOptions;
};

export enum MachineBatteryDischargeStatus {
  Critical = 'CRITICAL',
  Ok = 'OK',
  Warning = 'WARNING'
}

export enum MachineClassification {
  Gcd = 'GCD',
  NonIot = 'NON_IOT',
  Robot = 'ROBOT'
}

export enum MachineConnectionStatus {
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Unknown = 'UNKNOWN'
}

export type MachineFilter = {
  __typename?: 'MachineFilter';
  batteryDischargeStatuses: Array<BatteryDischargeStatus>;
  classifications: Array<MachineClassification>;
  dataStatuses: Array<DataStatus>;
  financeTypes: Array<FinanceType>;
  geofenceStatuses: Array<MachineGeofenceStatus>;
  machineTypes: Array<MachineTypeFilter>;
  servicePackages: Array<ServicePackage>;
  sites: Array<SiteFilter>;
  subclassifications: Array<MachineSubclassification>;
  utilizations: Array<MachineUtilization>;
};

export enum MachineGeofenceStatus {
  Inside = 'INSIDE',
  NoData = 'NO_DATA',
  Outside = 'OUTSIDE'
}

export type MachineId = {
  __typename?: 'MachineId';
  id: Scalars['ID']['output'];
};

export type MachineMetadata = {
  __typename?: 'MachineMetadata';
  finance?: Maybe<Finance>;
  inventoryNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  service?: Maybe<Service>;
};

export type MachineNote = {
  __typename?: 'MachineNote';
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: NoteCreator;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isUpdated: Scalars['Boolean']['output'];
  machineId: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type MachinePositionHistory = {
  __typename?: 'MachinePositionHistory';
  accuracy: Scalars['Float']['output'];
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  customerId: Scalars['String']['output'];
  enteredAt: Scalars['AWSDateTime']['output'];
  exitedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  machineId: Scalars['String']['output'];
  placeId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type MachineStatistics = {
  __typename?: 'MachineStatistics';
  actualOperatingTimeInMs: Scalars['Long']['output'];
  avgWorkingTimePerDayInMs: Scalars['Long']['output'];
  cleaningDays: Scalars['Int']['output'];
  deviationInMs: Scalars['Float']['output'];
  deviationInPercentage?: Maybe<Scalars['Float']['output']>;
  endAt: Scalars['AWSDateTime']['output'];
  fullfilmentInPerCentage: Scalars['Float']['output'];
  plannedDurationInMs: Scalars['Long']['output'];
  plannedOperatingTimeInMs: Scalars['Long']['output'];
  plannedShifts: Scalars['Int']['output'];
  startAt: Scalars['AWSDateTime']['output'];
  sumMissedCleaningJobs: Scalars['Int']['output'];
};

export enum MachineSubclassification {
  Iot = 'IOT',
  NonIot = 'NON_IOT'
}

export type MachineType = {
  __typename?: 'MachineType';
  materialNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MachineTypeByName = {
  __typename?: 'MachineTypeByName';
  materialNumbers?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MachineTypeFilter = {
  __typename?: 'MachineTypeFilter';
  materialNumbers: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type MachineUpdate = {
  __typename?: 'MachineUpdate';
  customerId: Scalars['String']['output'];
  data?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  machineId: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['String']['output']>;
};

export enum MachineUtilization {
  NotUsed = 'NOT_USED',
  Used = 'USED'
}

export enum MachineUtilizationStatus {
  NotUsed = 'NOT_USED',
  Used = 'USED'
}

export type MachineUtilizationStatusCount = {
  __typename?: 'MachineUtilizationStatusCount';
  count: Scalars['Int']['output'];
  status: MachineUtilizationStatus;
};

export type MachineVariant = {
  __typename?: 'MachineVariant';
  id: Scalars['ID']['output'];
  materialNumber: Scalars['String']['output'];
  picture: MachineVariantPicture;
};

export type MachineVariantPicture = {
  __typename?: 'MachineVariantPicture';
  overview: Scalars['String']['output'];
  product: Scalars['String']['output'];
  thumbnail: Scalars['String']['output'];
};

export type MachineVncRequestInput = {
  machineId: Scalars['ID']['input'];
};

export type MachineVncRequestResponse = {
  __typename?: 'MachineVncRequestResponse';
  expiresAt: Scalars['AWSDateTime']['output'];
  machineId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MachineVncRequestResponseV2 = {
  __typename?: 'MachineVncRequestResponseV2';
  expiresAt: Scalars['AWSDateTime']['output'];
  region: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export enum MachineVncStatus {
  Failed = 'FAILED',
  Running = 'RUNNING',
  Waiting = 'WAITING'
}

export type MachineVncStatusGetInput = {
  machineId: Scalars['ID']['input'];
};

export type MachineVncStatusGetInputV2 = {
  machineId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type MachineVncStatusGetResponse = {
  __typename?: 'MachineVncStatusGetResponse';
  code: Array<Scalars['String']['output']>;
  status: MachineVncStatus;
};

export type MachinesExportFile = {
  __typename?: 'MachinesExportFile';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  status: AsyncJobStatus;
};

export type MachinesListExportRequestOutput = {
  __typename?: 'MachinesListExportRequestOutput';
  requestId: Scalars['String']['output'];
};

export type MachinesReport = {
  __typename?: 'MachinesReport';
  accuracy?: Maybe<Scalars['Float']['output']>;
  activatedAt: Scalars['AWSDateTime']['output'];
  address?: Maybe<Scalars['String']['output']>;
  batteryDischargeStatus?: Maybe<BatteryDischargeStatus>;
  classification?: Maybe<MachineClassification>;
  connectionStatus: MachineConnectionStatus;
  customerId: Scalars['String']['output'];
  geofenceStatus?: Maybe<MachineGeofenceStatus>;
  isIoTDevice?: Maybe<Scalars['Boolean']['output']>;
  lastActivityAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastConnectedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  machineId: Scalars['ID']['output'];
  machineTypeName: Scalars['String']['output'];
  materialNumber: Scalars['String']['output'];
  metadata?: Maybe<MachineMetadata>;
  serialNumber: Scalars['String']['output'];
  site?: Maybe<MachinesReportSite>;
  softwareVersion?: Maybe<Scalars['String']['output']>;
  statistics?: Maybe<MachineStatistics>;
  totalOperatingTimeInSeconds: Scalars['Int']['output'];
};

export type MachinesReportExport = {
  __typename?: 'MachinesReportExport';
  requestId: Scalars['String']['output'];
};

export type MachinesReportSite = {
  __typename?: 'MachinesReportSite';
  managers: Array<MachinesReportUser>;
  name: Scalars['String']['output'];
  siteId: Scalars['ID']['output'];
};

export type MachinesReportSubscription = {
  __typename?: 'MachinesReportSubscription';
  customerId: Scalars['String']['output'];
  email: Scalars['AWSEmail']['output'];
  lang: SupportedLanguage;
  reportFileFormats: Array<MachinesReportSubscriptionReportFileFormat>;
  reportInterval: MachinesReportSubscriptionReportInterval;
  reportType: MachinesReportSubscriptionReportType;
  userId: Scalars['String']['output'];
};

export enum MachinesReportSubscriptionReportFileFormat {
  Excel = 'EXCEL',
  Pdf = 'PDF'
}

export enum MachinesReportSubscriptionReportInterval {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum MachinesReportSubscriptionReportType {
  Total = 'TOTAL'
}

export type MachinesReportUser = {
  __typename?: 'MachinesReportUser';
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type Manager = {
  __typename?: 'Manager';
  userId: Scalars['ID']['output'];
};

export type ManualMachineDashboard = {
  __typename?: 'ManualMachineDashboard';
  batteryDischargeStatus: Array<BatteryDischargeStatusCount>;
  dataStatus: Array<DataStatusCount>;
  geofenceStatus: Array<GeofenceStatusCount>;
  machineUtilizationStatus: Array<MachineUtilizationStatusCount>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptTermsAndCondition?: Maybe<ResponseAcceptTermsAndCondition>;
  cleaningReportSubscriptionUpdateBatch?: Maybe<ResponseCleaningReportSubscriptions>;
  cleaningReportsExportRequest?: Maybe<ResponseCleaningReportsExportRequest>;
  machineAttachmentDelete?: Maybe<ResponseAttachmentDelete>;
  machineNoteCreate?: Maybe<ResponseMachineNoteCreate>;
  machineNoteDelete?: Maybe<ResponseBoolean>;
  machineNoteUpdate?: Maybe<ResponseMachineNoteUpdate>;
  machineUpdate?: Maybe<ResponseMachineUpdate>;
  machineVncRequest?: Maybe<ResponseMachineVncRequest>;
  machineVncRequestV2?: Maybe<ResponseMachineVncRequestV2>;
  machinesListExportRequest?: Maybe<ResponseMachinesListExportRequest>;
  machinesReportExportRequest?: Maybe<ResponseMachinesReportExportRequest>;
  machinesReportSubscriptionsReset?: Maybe<ResponseMachinesReportSubscriptions>;
  notificationDeleteOperator?: Maybe<ResponseNotificationDeleteOperator>;
  notificationUpdateNotifyStatus?: Maybe<ResponseNotificationUpdateNotifyStatus>;
  notificationUpsertOperator?: Maybe<ResponseNotificationUpsertOperator>;
  publishMachineUpdate?: Maybe<MachineUpdate>;
  reminderCreate?: Maybe<ResponseReminderCreate>;
  reminderDelete?: Maybe<ResponseBoolean>;
  robotDetailsReportsExportRequest?: Maybe<ResponseRobotDetailsReportsExportRequest>;
  routineReportExportRequest?: Maybe<ResponseRoutineReportExportRequest>;
  siteAssignMachine?: Maybe<ResponseSiteAssignMachine>;
  siteAssignManagers?: Maybe<ResponseSiteAssignManagers>;
  siteCreate?: Maybe<ResponseSiteCreate>;
  siteDelete?: Maybe<ResponseBoolean>;
  siteGeofenceSetup?: Maybe<ResponseBoolean>;
  siteTagAdd?: Maybe<ResponseSiteTagAdd>;
  siteTagRemove?: Maybe<ResponseBoolean>;
  siteTagsOverride?: Maybe<ResponseSiteTagsOverride>;
  siteUnassignMachine?: Maybe<ResponseSiteUnassignMachine>;
  siteUnassignManager?: Maybe<ResponseSiteUnassignManager>;
  siteUpdate?: Maybe<ResponseSiteUpdate>;
  userDeleteByEmail?: Maybe<ResponseBoolean>;
  userInvite?: Maybe<ResponseUserInvite>;
  userUnauthorize?: Maybe<ResponseUserUnauthorize>;
  userUpdate?: Maybe<ResponseUserUpdate>;
  workIntervalCreate?: Maybe<ResponseWorkIntervalCreate>;
  workIntervalDelete?: Maybe<ResponseBoolean>;
  workIntervalUpdate?: Maybe<ResponseWorkIntervalUpdate>;
};


export type MutationAcceptTermsAndConditionArgs = {
  input: InputAcceptTermsAndCondition;
};


export type MutationCleaningReportSubscriptionUpdateBatchArgs = {
  cleaningReportSubscriptions: Array<InputCleaningReportSubscription>;
  lang: SupportedLanguage;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCleaningReportsExportRequestArgs = {
  filter: InputFilterCleaningReportsExportRequest;
  lang: SupportedLanguage;
  sortOptions?: InputMaybe<InputSortOptions>;
  timezone: Scalars['String']['input'];
};


export type MutationMachineAttachmentDeleteArgs = {
  attachmentId: Scalars['ID']['input'];
  machineId: Scalars['ID']['input'];
};


export type MutationMachineNoteCreateArgs = {
  input: InputMachineNoteCreate;
};


export type MutationMachineNoteDeleteArgs = {
  id: Scalars['ID']['input'];
  machineId: Scalars['String']['input'];
};


export type MutationMachineNoteUpdateArgs = {
  input: InputMachineNoteUpdate;
};


export type MutationMachineUpdateArgs = {
  id: Scalars['ID']['input'];
  input: InputMachineUpdate;
};


export type MutationMachineVncRequestArgs = {
  input: MachineVncRequestInput;
};


export type MutationMachineVncRequestV2Args = {
  input: MachineVncRequestInput;
};


export type MutationMachinesListExportRequestArgs = {
  filter?: InputMaybe<InputFilterMachinesList>;
  lang: SupportedLanguage;
  sortOptions?: InputMaybe<InputSortOptions>;
  timezone: Scalars['String']['input'];
};


export type MutationMachinesReportExportRequestArgs = {
  columns?: InputMaybe<Array<Column>>;
  filter: InputFilterMachinesReport;
  lang: SupportedLanguage;
  period: InputPeriod;
  search?: InputMaybe<Scalars['String']['input']>;
  sortOptions?: InputMaybe<InputSortOptions>;
  timezone: Scalars['String']['input'];
};


export type MutationMachinesReportSubscriptionsResetArgs = {
  input: Array<InputMachinesReportSubscription>;
};


export type MutationNotificationDeleteOperatorArgs = {
  id: Scalars['String']['input'];
};


export type MutationNotificationUpdateNotifyStatusArgs = {
  input: InputNotificationUpdateNotifyStatus;
};


export type MutationNotificationUpsertOperatorArgs = {
  input: InputNotificationUpsertOperator;
};


export type MutationPublishMachineUpdateArgs = {
  customerId: Scalars['String']['input'];
  data?: InputMaybe<Scalars['String']['input']>;
  event: Scalars['String']['input'];
  machineId: Scalars['String']['input'];
  publishedAt: Scalars['String']['input'];
};


export type MutationReminderCreateArgs = {
  input: InputReminderCreate;
};


export type MutationReminderDeleteArgs = {
  id: Scalars['ID']['input'];
  machineId: Scalars['ID']['input'];
};


export type MutationRobotDetailsReportsExportRequestArgs = {
  id: Scalars['String']['input'];
  lang: SupportedLanguage;
  machineId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};


export type MutationRoutineReportExportRequestArgs = {
  executionId: Scalars['String']['input'];
  lang: SupportedLanguage;
  timezone: Scalars['String']['input'];
};


export type MutationSiteAssignMachineArgs = {
  input: InputSiteAssignMachine;
};


export type MutationSiteAssignManagersArgs = {
  input: InputSiteAssignManagers;
};


export type MutationSiteCreateArgs = {
  input: InputSiteCreate;
};


export type MutationSiteDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSiteGeofenceSetupArgs = {
  id: Scalars['ID']['input'];
  input: InputSiteGeofenceSetup;
};


export type MutationSiteTagAddArgs = {
  id: Scalars['ID']['input'];
  input: InputSiteTagAdd;
};


export type MutationSiteTagRemoveArgs = {
  id: Scalars['ID']['input'];
  input: InputSiteTagRemove;
};


export type MutationSiteTagsOverrideArgs = {
  id: Scalars['ID']['input'];
  input: InputSiteTagsOverride;
};


export type MutationSiteUnassignMachineArgs = {
  input: InputSiteUnassignMachine;
};


export type MutationSiteUnassignManagerArgs = {
  input: InputSiteUnassignManager;
};


export type MutationSiteUpdateArgs = {
  id: Scalars['ID']['input'];
  input: InputSiteUpdate;
};


export type MutationUserDeleteByEmailArgs = {
  input: InputUserDeleteByEmail;
};


export type MutationUserInviteArgs = {
  input: InputUserInvite;
};


export type MutationUserUnauthorizeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUserUpdateArgs = {
  id: Scalars['ID']['input'];
  input: InputUserUpdate;
};


export type MutationWorkIntervalCreateArgs = {
  input: InputWorkIntervalCreate;
};


export type MutationWorkIntervalDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWorkIntervalUpdateArgs = {
  id: Scalars['ID']['input'];
  input: InputWorkIntervalUpdate;
};

export type NoteCreator = {
  __typename?: 'NoteCreator';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  data?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  machine: Machine;
  message?: Maybe<NotificationMessage>;
  severity: Scalars['String']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
  type: Scalars['String']['output'];
};

export enum NotificationCategory {
  NotifyAutonomousTaskStopped = 'notifyAutonomousTaskStopped',
  NotifyBatteryDeepDischarge = 'notifyBatteryDeepDischarge',
  NotifyCleaningTaskFinished = 'notifyCleaningTaskFinished',
  NotifyCleaningTaskInterrupted = 'notifyCleaningTaskInterrupted',
  NotifyEmergencyStop = 'notifyEmergencyStop',
  NotifyErrorOccurred = 'notifyErrorOccurred',
  NotifyInformation = 'notifyInformation',
  NotifyLocationStatus = 'notifyLocationStatus',
  NotifyNoWorkStart = 'notifyNoWorkStart',
  NotifyOther = 'notifyOther',
  NotifyPcm = 'notifyPCM',
  NotifyReminder = 'notifyReminder',
  NotifyResources = 'notifyResources',
  NotifyServiceNeeded = 'notifyServiceNeeded'
}

export type NotificationMessage = {
  __typename?: 'NotificationMessage';
  cause?: Maybe<Scalars['String']['output']>;
  consequence?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type NotificationOperator = {
  __typename?: 'NotificationOperator';
  assignedMachines: Array<Maybe<AssignedMachineType>>;
  countryCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailSubscription?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notifyAutonomousTaskStopped?: Maybe<Scalars['Boolean']['output']>;
  notifyBatteryDeepDischarge?: Maybe<Scalars['Boolean']['output']>;
  notifyCleaningTaskFinished?: Maybe<Scalars['Boolean']['output']>;
  notifyCleaningTaskInterrupted?: Maybe<Scalars['Boolean']['output']>;
  notifyEmergencyStop?: Maybe<Scalars['Boolean']['output']>;
  notifyErrorOccurred?: Maybe<Scalars['Boolean']['output']>;
  notifyInformation?: Maybe<Scalars['Boolean']['output']>;
  notifyLocationStatus?: Maybe<Scalars['Boolean']['output']>;
  notifyNoWorkStart?: Maybe<Scalars['Boolean']['output']>;
  notifyOther?: Maybe<Scalars['Boolean']['output']>;
  notifyPCM?: Maybe<Scalars['Boolean']['output']>;
  notifyReminder?: Maybe<Scalars['Boolean']['output']>;
  notifyResources?: Maybe<Scalars['Boolean']['output']>;
  notifyServiceNeeded?: Maybe<Scalars['Boolean']['output']>;
  numberOfAssignedMachines?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export enum NotificationSeverity {
  Alert = 'ALERT',
  Informative = 'INFORMATIVE',
  NeedForAction = 'NEED_FOR_ACTION'
}

export type NotificationUser = {
  __typename?: 'NotificationUser';
  assignedMachines: Array<Maybe<AssignedMachineType>>;
  countryCode?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailSubscription?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  notifyAutonomousTaskStopped?: Maybe<Scalars['Boolean']['output']>;
  notifyBatteryDeepDischarge?: Maybe<Scalars['Boolean']['output']>;
  notifyCleaningTaskFinished?: Maybe<Scalars['Boolean']['output']>;
  notifyCleaningTaskInterrupted?: Maybe<Scalars['Boolean']['output']>;
  notifyEmergencyStop?: Maybe<Scalars['Boolean']['output']>;
  notifyErrorOccurred?: Maybe<Scalars['Boolean']['output']>;
  notifyInformation?: Maybe<Scalars['Boolean']['output']>;
  notifyLocationStatus?: Maybe<Scalars['Boolean']['output']>;
  notifyNoWorkStart?: Maybe<Scalars['Boolean']['output']>;
  notifyOther?: Maybe<Scalars['Boolean']['output']>;
  notifyPCM?: Maybe<Scalars['Boolean']['output']>;
  notifyReminder?: Maybe<Scalars['Boolean']['output']>;
  notifyResources?: Maybe<Scalars['Boolean']['output']>;
  notifyServiceNeeded?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UserRole>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type OperatingTimeInterval = {
  __typename?: 'OperatingTimeInterval';
  actualOperatingTimeMs: Scalars['Long']['output'];
  deviationMs: Scalars['Long']['output'];
  endAt: Scalars['AWSDateTime']['output'];
  plannedOperatingTimeMs: Scalars['Long']['output'];
  startAt: Scalars['AWSDateTime']['output'];
};

export type OperatingTimePeriod = {
  __typename?: 'OperatingTimePeriod';
  actualTotalOperatingTimeMs: Scalars['Long']['output'];
  endAt: Scalars['AWSDateTime']['output'];
  operatingTimeIntervals?: Maybe<Array<OperatingTimeInterval>>;
  plannedTotalOperatingTimeMs: Scalars['Long']['output'];
  startAt: Scalars['AWSDateTime']['output'];
};


export type OperatingTimePeriodOperatingTimeIntervalsArgs = {
  timezone: Scalars['String']['input'];
};

export type OperatingTimePeriodByDay = {
  __typename?: 'OperatingTimePeriodByDay';
  endAt: Scalars['AWSDateTime']['output'];
  startAt: Scalars['AWSDateTime']['output'];
};

export type OperatingTimePlanndAndActualForPeriod = {
  __typename?: 'OperatingTimePlanndAndActualForPeriod';
  actualCleaning?: Maybe<Array<Maybe<OperatingTimePeriodByDay>>>;
  plannedCleaning?: Maybe<Array<Maybe<PlannedOperatingTimeInterval>>>;
};

export type PlannedOperatingTimeInterval = {
  __typename?: 'PlannedOperatingTimeInterval';
  endAt: Scalars['AWSDateTime']['output'];
  plannedDurationMs?: Maybe<Scalars['Long']['output']>;
  startAt: Scalars['AWSDateTime']['output'];
};

export type Query = {
  __typename?: 'Query';
  attachmentDownloadLinkGet?: Maybe<ResponseAttachmentDownloadLinkGet>;
  attachmentNameCheck?: Maybe<ResponseAttachmentNameCheck>;
  attachmentUploadLinkGet?: Maybe<ResponseAttachmentUploadLinkGet>;
  cleaningReportSubscriptions?: Maybe<ResponseCleaningReportSubscriptions>;
  cleaningReportsExportGetFile?: Maybe<ResponseGetCleaningReportsExportFile>;
  cleaningTaskCleanedAreaByDayList?: Maybe<ResponseCleaningTaskCleanedAreaByDayList>;
  cleaningTaskCleanedHrsByDayList?: Maybe<ResponseCleaningTaskCleanedHrsByDayList>;
  cleaningTaskConsumablesByDayList?: Maybe<ResponseCleaningTaskConsumablesByDayList>;
  cleaningTaskDistanceDrivenByDayList?: Maybe<ResponseCleaningTaskDistanceDrivenByDayList>;
  cleaningTaskReportRobotRouteImage?: Maybe<ResponseString>;
  cleaningTaskReports?: Maybe<ResponseCleaningTaskReportsList>;
  fleetOperatingTime?: Maybe<ResponseFleetOperatingTime>;
  listPlannedAndActualForPeriod?: Maybe<ResponseOperatingTimePlanndAndActualForPeriod>;
  machine?: Maybe<ResponseMachineGet>;
  machineFilter?: Maybe<ResponseMachineFilter>;
  machineIds?: Maybe<ResponseMachineIdsList>;
  machinePositionHistories?: Maybe<ResponseMachinePositionHistories>;
  machineTypes?: Maybe<ResponseMachineTypesList>;
  machineVariants?: Maybe<ResponseMachineVariantsList>;
  machineVncStatusGet?: Maybe<ResponseMachineVncStatusGet>;
  machineVncStatusGetV2?: Maybe<ResponseMachineVncStatusGetV2>;
  machines?: Maybe<ResponseMachinesList>;
  machinesAvailableToBeAssigned?: Maybe<ResponseMachinesAvailableToBeAssigned>;
  machinesExportFile?: Maybe<ResponseMachinesExportFile>;
  machinesReport?: Maybe<ResponseMachinesReportList>;
  machinesReportExportGet?: Maybe<ResponseGetMachinesReportExport>;
  machinesReportSubscriptionsList?: Maybe<ResponseMachinesReportSubscriptions>;
  manualMachineDashboard?: Maybe<ResponseManualMachineDashboard>;
  notificationGetOperator?: Maybe<ResponseNotificationGetOperator>;
  notificationGetUser?: Maybe<ResponseNotificationUser>;
  notificationListOperator?: Maybe<ResponseNotificationListOperator>;
  notifications?: Maybe<ResponseNotificationsList>;
  robotCleaningRoutesList?: Maybe<ResponseRobotCleaningRoutesList>;
  robotConsumptionSummary?: Maybe<ResponseRobotCleaningConsumptionSummary>;
  robotConsumptionsList?: Maybe<ResponseRobotCleaningConsumptionsList>;
  robotDashboardKPIs?: Maybe<ResponseRobotDashboardKpIsGet>;
  robotDashboardTotalCleanedArea?: Maybe<ResponseRobotDashboardTotalCleanedAreaGet>;
  robotDashboardTotalCleanedHrs?: Maybe<ResponseRobotDashboardTotalCleanedHrsGet>;
  robotTaskCompletionStatistic?: Maybe<ResponseRobotTaskCompletionStatisticGet>;
  routineCleaningTaskReport?: Maybe<ResponseRoutineCleaningTaskReport>;
  singleRoutesAndRoutinesList?: Maybe<ResponseSingleRoutesAndRoutinesList>;
  site?: Maybe<ResponseSiteGet>;
  siteAddressCoordinate?: Maybe<ResponseSiteAddressCoordinateGet>;
  siteAddressesSuggestion?: Maybe<ResponseSiteAddressesSuggestionList>;
  sites?: Maybe<ResponseSitesList>;
  tags?: Maybe<ResponseTagsList>;
  tagsItems?: Maybe<ResponseTagsItemsGet>;
  usermachinesClassificationsCheck?: Maybe<ResponseCheckAccessibleClassification>;
  users?: Maybe<ResponseUsersList>;
  workIntervals?: Maybe<ResponseWorkIntervalsList>;
};


export type QueryAttachmentDownloadLinkGetArgs = {
  attachmentId: Scalars['String']['input'];
  machineId: Scalars['ID']['input'];
};


export type QueryAttachmentNameCheckArgs = {
  attachmentName: Scalars['String']['input'];
  machineId: Scalars['ID']['input'];
};


export type QueryAttachmentUploadLinkGetArgs = {
  attachmentName: Scalars['String']['input'];
  isOverride?: InputMaybe<Scalars['Boolean']['input']>;
  machineId: Scalars['ID']['input'];
  mimeType: Scalars['String']['input'];
};


export type QueryCleaningReportsExportGetFileArgs = {
  requestId: Scalars['String']['input'];
};


export type QueryCleaningTaskCleanedAreaByDayListArgs = {
  filter: InputFilterCleaningTaskCleanedAreaByDayList;
};


export type QueryCleaningTaskCleanedHrsByDayListArgs = {
  filter: InputFilterCleaningTaskCleanedHrsByDayList;
};


export type QueryCleaningTaskConsumablesByDayListArgs = {
  filter: InputFilterCleaningTaskConsumablesByDayList;
};


export type QueryCleaningTaskDistanceDrivenByDayListArgs = {
  filter: InputFilterCleaningTaskDistanceDrivenByDayList;
};


export type QueryCleaningTaskReportRobotRouteImageArgs = {
  finishedAt: Scalars['String']['input'];
  machineId: Scalars['String']['input'];
};


export type QueryCleaningTaskReportsArgs = {
  filter: InputFilterCleaningTaskReportsList;
  paginationOptions: InputPagingOptions;
  sortOptions?: InputMaybe<InputSortOptions>;
};


export type QueryFleetOperatingTimeArgs = {
  filter: InputFilterFleetOperatingTime;
};


export type QueryListPlannedAndActualForPeriodArgs = {
  filter: InputListPlannedAndActualForPeriod;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMachineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMachineFilterArgs = {
  filter?: InputMaybe<InputMachineFilterFilter>;
  timezone: Scalars['String']['input'];
};


export type QueryMachineIdsArgs = {
  filter?: InputMaybe<InputFilterMachineIdsList>;
};


export type QueryMachinePositionHistoriesArgs = {
  machineId: Scalars['ID']['input'];
  paginationOptions?: InputMaybe<InputPagingOptions>;
  period: InputPeriod;
};


export type QueryMachineVncStatusGetArgs = {
  input: MachineVncStatusGetInput;
};


export type QueryMachineVncStatusGetV2Args = {
  input: MachineVncStatusGetInputV2;
};


export type QueryMachinesArgs = {
  filter?: InputMaybe<InputFilterMachinesList>;
  paginationOptions?: InputMaybe<InputPagingOptions>;
  sortOptions?: InputMaybe<InputSortOptions>;
};


export type QueryMachinesExportFileArgs = {
  id: Scalars['String']['input'];
};


export type QueryMachinesReportArgs = {
  filter: InputFilterMachinesReport;
  paginationOptions?: InputMaybe<InputPagingOptions>;
  period: InputPeriod;
  search?: InputMaybe<Scalars['String']['input']>;
  sortOptions?: InputMaybe<InputSortOptions>;
  timezone: Scalars['String']['input'];
};


export type QueryMachinesReportExportGetArgs = {
  requestId: Scalars['String']['input'];
};


export type QueryManualMachineDashboardArgs = {
  filter?: InputMaybe<InputFilterManualMachineDashboard>;
  period: InputPeriod;
};


export type QueryNotificationGetOperatorArgs = {
  id: Scalars['String']['input'];
};


export type QueryNotificationListOperatorArgs = {
  paginationOptions: InputPagingOptions;
};


export type QueryNotificationsArgs = {
  filter?: InputMaybe<InputFilterNotificationsList>;
  lang?: InputMaybe<Scalars['String']['input']>;
  paginationOptions: InputPagingOptions;
  sortOptions?: InputMaybe<InputSortOptions>;
};


export type QueryRobotCleaningRoutesListArgs = {
  filter: InputFilterRobotCleaningRoutesList;
};


export type QueryRobotConsumptionSummaryArgs = {
  filter: InputFilterCleaningConsumption;
};


export type QueryRobotConsumptionsListArgs = {
  filter: InputFilterCleaningConsumption;
};


export type QueryRobotDashboardKpIsArgs = {
  filter: InputFilterRobotDashboardKpIsGet;
  paginationOptions: InputPagingOptions;
};


export type QueryRobotDashboardTotalCleanedAreaArgs = {
  filter: InputFilterRobotDashboardTotalCleanedAreaGet;
  paginationOptions: InputPagingOptions;
};


export type QueryRobotDashboardTotalCleanedHrsArgs = {
  filter: InputFilterRobotDashboardTotalCleanedHrsGet;
  paginationOptions: InputPagingOptions;
};


export type QueryRobotTaskCompletionStatisticArgs = {
  filter: InputFilterRobotTaskCompletionStatisticGet;
};


export type QueryRoutineCleaningTaskReportArgs = {
  filter: InputFilterRoutineCleaningTaskReport;
};


export type QuerySingleRoutesAndRoutinesListArgs = {
  filter: InputFilterSingleRoutesAndRoutinesList;
  paginationOptions: InputPagingOptions;
  search?: InputMaybe<Scalars['String']['input']>;
  sortOptions?: InputMaybe<InputSortOptions>;
};


export type QuerySiteArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySiteAddressCoordinateArgs = {
  filter: InputFilterSiteAddressCoordinateGet;
};


export type QuerySiteAddressesSuggestionArgs = {
  filter: InputFilterSiteAddressesSuggestionList;
  paginationOptions: InputSiteAddressesSuggestionListPagingOptions;
};


export type QuerySitesArgs = {
  filter?: InputMaybe<InputFilterSitesList>;
  paginationOptions: InputPagingOptions;
  sortOptions?: InputMaybe<InputSortOptions>;
};


export type QueryTagsArgs = {
  filter?: InputMaybe<InputFilterTagsList>;
  paginationOptions: InputPagingOptions;
};


export type QueryTagsItemsArgs = {
  filter: InputFilterTagsItemsGet;
};


export type QueryUsersArgs = {
  filter?: InputMaybe<InputFilterUsersList>;
  paginationOptions: InputPagingOptions;
};


export type QueryWorkIntervalsArgs = {
  filter: InputFilterWorkIntervalsList;
};

export enum RecurrenceInterval {
  EveryWeek = 'EVERY_WEEK'
}

export type Reminder = {
  __typename?: 'Reminder';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastRemindAt?: Maybe<Scalars['AWSDateTime']['output']>;
  localRepetitiveDate: Scalars['AWSDate']['output'];
  localRepetitiveTime: Scalars['AWSTime']['output'];
  machineId: Scalars['String']['output'];
  nextRemindAt: Scalars['AWSDateTime']['output'];
  repetition: RepetitionInterval;
  startAt: Scalars['AWSDateTime']['output'];
  timezone: Scalars['String']['output'];
  topic: Scalars['String']['output'];
};

export enum RepetitionInterval {
  Every_3Months = 'EVERY_3_MONTHS',
  Every_6Months = 'EVERY_6_MONTHS',
  Monthly = 'MONTHLY',
  Once = 'ONCE',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum ReportType {
  EventReport = 'EVENT_REPORT',
  RobotReport = 'ROBOT_REPORT',
  TotalReport = 'TOTAL_REPORT'
}

export type ResponseAcceptTermsAndCondition = {
  __typename?: 'ResponseAcceptTermsAndCondition';
  data?: Maybe<Array<AcceptTermsAndCondition>>;
};

export type ResponseAttachmentDelete = {
  __typename?: 'ResponseAttachmentDelete';
  data: Scalars['Boolean']['output'];
};

export type ResponseAttachmentDownloadLinkGet = {
  __typename?: 'ResponseAttachmentDownloadLinkGet';
  data?: Maybe<Scalars['String']['output']>;
};

export type ResponseAttachmentNameCheck = {
  __typename?: 'ResponseAttachmentNameCheck';
  data?: Maybe<AttachmentNameCheck>;
};

export type ResponseAttachmentUploadLinkGet = {
  __typename?: 'ResponseAttachmentUploadLinkGet';
  data?: Maybe<AttachmentUploadLinkData>;
};

export type ResponseBoolean = {
  __typename?: 'ResponseBoolean';
  data: Scalars['Boolean']['output'];
};

export type ResponseCheckAccessibleClassification = {
  __typename?: 'ResponseCheckAccessibleClassification';
  hasAccessToGCD?: Maybe<Scalars['Boolean']['output']>;
  hasAccessToRobots?: Maybe<Scalars['Boolean']['output']>;
};

export type ResponseCleaningReportSubscriptions = {
  __typename?: 'ResponseCleaningReportSubscriptions';
  data: Array<CleaningReportSubscription>;
};

export type ResponseCleaningReportsExportRequest = {
  __typename?: 'ResponseCleaningReportsExportRequest';
  data: CleaningReportsExportRequestOutput;
};

export type ResponseCleaningStatistic = {
  __typename?: 'ResponseCleaningStatistic';
  data?: Maybe<RobotDashboardKpIsData>;
};

export type ResponseCleaningTaskCleanedAreaByDayList = {
  __typename?: 'ResponseCleaningTaskCleanedAreaByDayList';
  data: CleaningTaskCleanedAreaByDayList;
};

export type ResponseCleaningTaskCleanedHrsByDayList = {
  __typename?: 'ResponseCleaningTaskCleanedHrsByDayList';
  data: CleaningTaskCleanedHrsByDayList;
};

export type ResponseCleaningTaskConsumablesByDayList = {
  __typename?: 'ResponseCleaningTaskConsumablesByDayList';
  data: CleaningTaskConsumablesByDayList;
};

export type ResponseCleaningTaskDistanceDrivenByDayList = {
  __typename?: 'ResponseCleaningTaskDistanceDrivenByDayList';
  data: CleaningTaskDistanceDrivenByDayList;
};

export type ResponseCleaningTaskReportsData = {
  __typename?: 'ResponseCleaningTaskReportsData';
  data: Array<CleaningTaskReport>;
};

export type ResponseCleaningTaskReportsList = {
  __typename?: 'ResponseCleaningTaskReportsList';
  data: Array<CleaningTaskReport>;
  metadata?: Maybe<ResponseMetadata>;
};

export type ResponseFleetOperatingTime = {
  __typename?: 'ResponseFleetOperatingTime';
  data: FleetOperatingTime;
};

export type ResponseGetCleaningReportsExportFile = {
  __typename?: 'ResponseGetCleaningReportsExportFile';
  data: GetExportFileOutput;
};

export type ResponseGetMachinesReportExport = {
  __typename?: 'ResponseGetMachinesReportExport';
  data?: Maybe<GetExportOutput>;
};

export type ResponseLatestCleaningTaskReport = {
  __typename?: 'ResponseLatestCleaningTaskReport';
  data?: Maybe<CleaningTaskReport>;
};

export type ResponseLatestRoutine = {
  __typename?: 'ResponseLatestRoutine';
  data?: Maybe<CleaningRoutine>;
};

export type ResponseMachineAttachmentsList = {
  __typename?: 'ResponseMachineAttachmentsList';
  data: Array<Attachment>;
  metadata?: Maybe<ResponseMetadata>;
};

export type ResponseMachineFilter = {
  __typename?: 'ResponseMachineFilter';
  data: MachineFilter;
};

export type ResponseMachineGet = {
  __typename?: 'ResponseMachineGet';
  data?: Maybe<Machine>;
};

export type ResponseMachineIdsList = {
  __typename?: 'ResponseMachineIdsList';
  data: Array<Scalars['ID']['output']>;
};

export type ResponseMachineNoteCreate = {
  __typename?: 'ResponseMachineNoteCreate';
  data: MachineNote;
};

export type ResponseMachineNoteUpdate = {
  __typename?: 'ResponseMachineNoteUpdate';
  data: MachineNote;
};

export type ResponseMachineNotesList = {
  __typename?: 'ResponseMachineNotesList';
  data: Array<MachineNote>;
  metadata?: Maybe<ResponseMetadata>;
};

export type ResponseMachinePositionHistories = {
  __typename?: 'ResponseMachinePositionHistories';
  data: Array<MachinePositionHistory>;
  metadata?: Maybe<ResponseMetadata>;
};

export type ResponseMachineTypesList = {
  __typename?: 'ResponseMachineTypesList';
  data: Array<MachineTypeByName>;
};

export type ResponseMachineUpdate = {
  __typename?: 'ResponseMachineUpdate';
  data: Machine;
};

export type ResponseMachineVariantsList = {
  __typename?: 'ResponseMachineVariantsList';
  data: Array<MachineVariant>;
};

export type ResponseMachineVncRequest = {
  __typename?: 'ResponseMachineVncRequest';
  data: MachineVncRequestResponse;
};

export type ResponseMachineVncRequestV2 = {
  __typename?: 'ResponseMachineVncRequestV2';
  data: MachineVncRequestResponseV2;
};

export type ResponseMachineVncStatusGet = {
  __typename?: 'ResponseMachineVncStatusGet';
  data: MachineVncStatusGetResponse;
};

export type ResponseMachineVncStatusGetV2 = {
  __typename?: 'ResponseMachineVncStatusGetV2';
  data: MachineVncStatusGetResponse;
};

export type ResponseMachinesAvailableToBeAssigned = {
  __typename?: 'ResponseMachinesAvailableToBeAssigned';
  data: Array<Machine>;
};

export type ResponseMachinesExportFile = {
  __typename?: 'ResponseMachinesExportFile';
  data: MachinesExportFile;
};

export type ResponseMachinesList = {
  __typename?: 'ResponseMachinesList';
  data: Array<Machine>;
  metadata?: Maybe<ResponseMetadata>;
};

export type ResponseMachinesListExportRequest = {
  __typename?: 'ResponseMachinesListExportRequest';
  data: MachinesListExportRequestOutput;
};

export type ResponseMachinesReportExportRequest = {
  __typename?: 'ResponseMachinesReportExportRequest';
  data: MachinesReportExport;
};

export type ResponseMachinesReportList = {
  __typename?: 'ResponseMachinesReportList';
  data: Array<MachinesReport>;
  metadata?: Maybe<ResponseMetadata>;
};

export type ResponseMachinesReportSubscriptions = {
  __typename?: 'ResponseMachinesReportSubscriptions';
  data: Array<MachinesReportSubscription>;
};

export type ResponseManualMachineDashboard = {
  __typename?: 'ResponseManualMachineDashboard';
  data: ManualMachineDashboard;
};

export type ResponseMetadata = {
  __typename?: 'ResponseMetadata';
  paginationToken?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type ResponseNotificationDeleteOperator = {
  __typename?: 'ResponseNotificationDeleteOperator';
  data?: Maybe<Scalars['Boolean']['output']>;
};

export type ResponseNotificationGetOperator = {
  __typename?: 'ResponseNotificationGetOperator';
  data?: Maybe<NotificationOperator>;
};

export type ResponseNotificationListOperator = {
  __typename?: 'ResponseNotificationListOperator';
  data: Array<NotificationOperator>;
  metadata?: Maybe<ResponseMetadata>;
};

export type ResponseNotificationUpdateNotifyStatus = {
  __typename?: 'ResponseNotificationUpdateNotifyStatus';
  data?: Maybe<NotificationUser>;
};

export type ResponseNotificationUpsertOperator = {
  __typename?: 'ResponseNotificationUpsertOperator';
  data?: Maybe<NotificationOperator>;
};

export type ResponseNotificationUser = {
  __typename?: 'ResponseNotificationUser';
  data?: Maybe<NotificationUser>;
};

export type ResponseNotificationsList = {
  __typename?: 'ResponseNotificationsList';
  data: Array<Notification>;
  metadata?: Maybe<ResponseMetadata>;
};

export type ResponseOperatingTimePlanndAndActualForPeriod = {
  __typename?: 'ResponseOperatingTimePlanndAndActualForPeriod';
  data: OperatingTimePlanndAndActualForPeriod;
};

export type ResponseReminderCreate = {
  __typename?: 'ResponseReminderCreate';
  data?: Maybe<Reminder>;
};

export type ResponseRemindersList = {
  __typename?: 'ResponseRemindersList';
  data: Array<Reminder>;
  metadata?: Maybe<ResponseMetadata>;
};

export type ResponseRobotCleaningConsumptionSummary = {
  __typename?: 'ResponseRobotCleaningConsumptionSummary';
  data?: Maybe<RobotCleaningConsumption>;
};

export type ResponseRobotCleaningConsumptionsList = {
  __typename?: 'ResponseRobotCleaningConsumptionsList';
  data?: Maybe<Array<Maybe<RobotCleaningConsumptionList>>>;
};

export type ResponseRobotCleaningRoutesList = {
  __typename?: 'ResponseRobotCleaningRoutesList';
  data: RobotCleaningRoutesListData;
};

export type ResponseRobotDashboardKpIsGet = {
  __typename?: 'ResponseRobotDashboardKPIsGet';
  data: RobotDashboardKpIsData;
};

export type ResponseRobotDashboardTotalCleanedAreaGet = {
  __typename?: 'ResponseRobotDashboardTotalCleanedAreaGet';
  data: Array<RobotDashboardTotalCleanedAreaData>;
  metadata?: Maybe<ResponseMetadata>;
};

export type ResponseRobotDashboardTotalCleanedHrsGet = {
  __typename?: 'ResponseRobotDashboardTotalCleanedHrsGet';
  data: Array<RobotDashboardTotalCleanedHrsData>;
  metadata?: Maybe<ResponseMetadata>;
};

export type ResponseRobotDetailsReportsExportRequest = {
  __typename?: 'ResponseRobotDetailsReportsExportRequest';
  data: RobotDetailsReportsExportRequestOutput;
};

export type ResponseRobotTaskCompletionStatisticGet = {
  __typename?: 'ResponseRobotTaskCompletionStatisticGet';
  data: RobotTaskCompletionStatisticData;
};

export type ResponseRoutineCleaningTaskReport = {
  __typename?: 'ResponseRoutineCleaningTaskReport';
  data: RoutineCleaningTaskReportData;
};

export type ResponseRoutineData = {
  __typename?: 'ResponseRoutineData';
  data: Routine;
};

export type ResponseRoutineReportExportRequest = {
  __typename?: 'ResponseRoutineReportExportRequest';
  data: RoutineReportExportRequestOutput;
};

export type ResponseSingleRoutesAndRoutinesList = {
  __typename?: 'ResponseSingleRoutesAndRoutinesList';
  data?: Maybe<Array<Maybe<SingleRoutesAndRoutineData>>>;
  metadata?: Maybe<ResponseMetadata>;
};

export type ResponseSiteAddressCoordinateGet = {
  __typename?: 'ResponseSiteAddressCoordinateGet';
  data?: Maybe<Coordinate>;
};

export type ResponseSiteAddressesSuggestionList = {
  __typename?: 'ResponseSiteAddressesSuggestionList';
  data: Array<Scalars['String']['output']>;
};

export type ResponseSiteAssignMachine = {
  __typename?: 'ResponseSiteAssignMachine';
  data: Array<Maybe<MachineId>>;
};

export type ResponseSiteAssignManagers = {
  __typename?: 'ResponseSiteAssignManagers';
  data?: Maybe<Array<Manager>>;
};

export type ResponseSiteCreate = {
  __typename?: 'ResponseSiteCreate';
  data: Site;
};

export type ResponseSiteGet = {
  __typename?: 'ResponseSiteGet';
  data: Site;
};

export type ResponseSiteTagAdd = {
  __typename?: 'ResponseSiteTagAdd';
  data: SiteTag;
};

export type ResponseSiteTagsOverride = {
  __typename?: 'ResponseSiteTagsOverride';
  data?: Maybe<SiteTagsOverride>;
};

export type ResponseSiteUnassignMachine = {
  __typename?: 'ResponseSiteUnassignMachine';
  data: MachineId;
};

export type ResponseSiteUnassignManager = {
  __typename?: 'ResponseSiteUnassignManager';
  data: Manager;
};

export type ResponseSiteUpdate = {
  __typename?: 'ResponseSiteUpdate';
  data: Site;
};

export type ResponseSitesList = {
  __typename?: 'ResponseSitesList';
  data: Array<Site>;
  metadata?: Maybe<ResponseMetadata>;
};

export type ResponseString = {
  __typename?: 'ResponseString';
  data: Scalars['String']['output'];
};

export type ResponseTagsItemsGet = {
  __typename?: 'ResponseTagsItemsGet';
  data: Array<Scalars['String']['output']>;
};

export type ResponseTagsList = {
  __typename?: 'ResponseTagsList';
  data: Array<Tag>;
  metadata?: Maybe<ResponseMetadata>;
};

export type ResponseUserInvite = {
  __typename?: 'ResponseUserInvite';
  data?: Maybe<Scalars['Boolean']['output']>;
};

export type ResponseUserUnauthorize = {
  __typename?: 'ResponseUserUnauthorize';
  data: User;
};

export type ResponseUserUpdate = {
  __typename?: 'ResponseUserUpdate';
  data: User;
};

export type ResponseUsersList = {
  __typename?: 'ResponseUsersList';
  data: Array<User>;
  metadata?: Maybe<ResponseMetadata>;
};

export type ResponseWorkIntervalCreate = {
  __typename?: 'ResponseWorkIntervalCreate';
  data: WorkInterval;
};

export type ResponseWorkIntervalUpdate = {
  __typename?: 'ResponseWorkIntervalUpdate';
  data: WorkInterval;
};

export type ResponseWorkIntervalsList = {
  __typename?: 'ResponseWorkIntervalsList';
  data: Array<WorkInterval>;
};

export type RobotCleaningConsumption = {
  __typename?: 'RobotCleaningConsumption';
  battery: Scalars['Float']['output'];
  detergents: Scalars['Float']['output'];
  water: Scalars['Float']['output'];
};

export type RobotCleaningConsumptionList = {
  __typename?: 'RobotCleaningConsumptionList';
  consumptions: RobotCleaningConsumption;
  finishedAt: Scalars['String']['output'];
};

export type RobotCleaningRoutesListData = {
  __typename?: 'RobotCleaningRoutesListData';
  unavailableRoute?: Maybe<Array<Maybe<RobotCleaningRoutesObject>>>;
  validRoute?: Maybe<Array<Maybe<RobotCleaningRoutesObject>>>;
};

export type RobotCleaningRoutesObject = {
  __typename?: 'RobotCleaningRoutesObject';
  recentFinishedAt: Scalars['AWSDateTime']['output'];
  routeName?: Maybe<Scalars['String']['output']>;
};

export type RobotDashboardKpIsData = {
  __typename?: 'RobotDashboardKPIsData';
  distanceDriven: Scalars['Float']['output'];
  taskCoverage: Scalars['Float']['output'];
  tasksCompleted: Scalars['Float']['output'];
  totalCleanedArea: Scalars['Int']['output'];
  totalCleaningHrs: Scalars['Float']['output'];
};

export type RobotDashboardTotalCleanedAreaData = {
  __typename?: 'RobotDashboardTotalCleanedAreaData';
  cleanedArea: Scalars['Int']['output'];
  machineId: Scalars['String']['output'];
  machineName: Scalars['String']['output'];
};

export type RobotDashboardTotalCleanedHrsData = {
  __typename?: 'RobotDashboardTotalCleanedHrsData';
  cleanedHrs: Scalars['Float']['output'];
  machineId: Scalars['String']['output'];
  machineName: Scalars['String']['output'];
};

export type RobotDetailsReportsExportRequestOutput = {
  __typename?: 'RobotDetailsReportsExportRequestOutput';
  requestId: Scalars['String']['output'];
};

export enum RobotStatus {
  Autonomous = 'Autonomous',
  Charging = 'Charging',
  Docking = 'Docking',
  Exploration = 'Exploration',
  Idle = 'Idle',
  ManualCleaning = 'ManualCleaning'
}

export type RobotTaskCompletionStatisticData = {
  __typename?: 'RobotTaskCompletionStatisticData';
  completed: Scalars['Int']['output'];
  interrupted: Scalars['Int']['output'];
  stopped: Scalars['Int']['output'];
};

export enum Role {
  CustomerAdmin = 'CUSTOMER_ADMIN',
  CustomerOperator = 'CUSTOMER_OPERATOR',
  CustomerStrategicManager = 'CUSTOMER_STRATEGIC_MANAGER'
}

export type Routine = {
  __typename?: 'Routine';
  currentRepeat?: Maybe<Scalars['Int']['output']>;
  executionId?: Maybe<Scalars['String']['output']>;
  numberOfRepeats?: Maybe<Scalars['Int']['output']>;
  routineName?: Maybe<Scalars['String']['output']>;
};

export type RoutineCleaningTaskReportData = {
  __typename?: 'RoutineCleaningTaskReportData';
  cleaningTaskReports: ResponseCleaningTaskReportsData;
  robotConsumptionSummary: ResponseRobotCleaningConsumptionSummary;
  robotDashboardKPIs: ResponseRobotDashboardKpIsGet;
  routine: ResponseRoutineData;
};

export enum RoutineCompletion {
  Completed = 'COMPLETED',
  Interrupted = 'INTERRUPTED',
  Stopped = 'STOPPED'
}

export type RoutineReportExportRequestOutput = {
  __typename?: 'RoutineReportExportRequestOutput';
  requestId: Scalars['String']['output'];
};

export enum RoutineStatus {
  Ended = 'ENDED',
  InProgress = 'IN_PROGRESS',
  Started = 'STARTED'
}

export type Service = {
  __typename?: 'Service';
  partNumber: Scalars['String']['output'];
  servicePackage: ServicePackage;
};

export enum ServicePackage {
  FullService = 'FULL_SERVICE',
  FullServiceWithBatteries = 'FULL_SERVICE_WITH_BATTERIES',
  FullServiceWithConsumables = 'FULL_SERVICE_WITH_CONSUMABLES',
  FullServiceWithConsumablesAndBatteries = 'FULL_SERVICE_WITH_CONSUMABLES_AND_BATTERIES',
  Inspect = 'INSPECT',
  InspectWithBatteries = 'INSPECT_WITH_BATTERIES',
  InspectWithConsumables = 'INSPECT_WITH_CONSUMABLES',
  InspectWithConsumablesAndBatteries = 'INSPECT_WITH_CONSUMABLES_AND_BATTERIES',
  Maintain = 'MAINTAIN',
  MaintainWithBatteries = 'MAINTAIN_WITH_BATTERIES',
  MaintainWithConsumables = 'MAINTAIN_WITH_CONSUMABLES',
  MaintainWithConsumablesAndBatteries = 'MAINTAIN_WITH_CONSUMABLES_AND_BATTERIES',
  NoServiceContract = 'NO_SERVICE_CONTRACT'
}

export enum Severity {
  Critical = 'Critical',
  Major = 'Major',
  Minor = 'Minor'
}

export enum SingleRouteAndRoutineType {
  Routine = 'ROUTINE',
  SingleRoute = 'SINGLE_ROUTE'
}

export type SingleRoutesAndRoutineData = {
  __typename?: 'SingleRoutesAndRoutineData';
  CTRId?: Maybe<Scalars['String']['output']>;
  actualOperatingTimeInSeconds?: Maybe<Scalars['Int']['output']>;
  battery?: Maybe<Scalars['Float']['output']>;
  cleanedSquareMeter?: Maybe<Scalars['Int']['output']>;
  customerId: Scalars['String']['output'];
  detergents?: Maybe<Scalars['Float']['output']>;
  executionId?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  machine?: Maybe<Machine>;
  machineId?: Maybe<Scalars['String']['output']>;
  machineName?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  pathCoverage?: Maybe<Scalars['Float']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
  routineMaps?: Maybe<Array<Maybe<Scalars['AWSDateTime']['output']>>>;
  routineName?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  taskCompletion?: Maybe<TaskCompletion>;
  type?: Maybe<SingleRouteAndRoutineType>;
  water?: Maybe<Scalars['Float']['output']>;
};

export type Site = {
  __typename?: 'Site';
  cleaningStatistic: ResponseCleaningStatistic;
  customerId: Scalars['String']['output'];
  geofence?: Maybe<SiteGeofence>;
  id: Scalars['ID']['output'];
  location?: Maybe<SiteLocation>;
  machines: ResponseMachinesList;
  managerIds?: Maybe<Array<Scalars['String']['output']>>;
  managers?: Maybe<Array<User>>;
  name: Scalars['String']['output'];
  numberMachinesAssigned: Scalars['Int']['output'];
  operatingTimeForPeriod?: Maybe<SiteOperatingTimePeriod>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};


export type SiteCleaningStatisticArgs = {
  filter: InputFilterSiteCleaningStatistic;
};


export type SiteMachinesArgs = {
  filter?: InputMaybe<InputFilterSiteMachinesList>;
  paginationOptions: InputPagingOptions;
};


export type SiteOperatingTimeForPeriodArgs = {
  period: InputPeriod;
};

export type SiteFilter = {
  __typename?: 'SiteFilter';
  name: Scalars['String']['output'];
  siteId: Scalars['ID']['output'];
};

export type SiteGeofence = {
  __typename?: 'SiteGeofence';
  centerPoint: Coordinate;
  id: Scalars['ID']['output'];
  radius: Scalars['Float']['output'];
};

export type SiteLocation = {
  __typename?: 'SiteLocation';
  address?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type SiteOperatingTimePeriod = {
  __typename?: 'SiteOperatingTimePeriod';
  actualTotalOperatingTimeMs: Scalars['Long']['output'];
  endAt: Scalars['AWSDateTime']['output'];
  plannedTotalOperatingTimeMs: Scalars['Long']['output'];
  startAt: Scalars['AWSDateTime']['output'];
};

export type SiteTag = {
  __typename?: 'SiteTag';
  customerId: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  tag: Scalars['String']['output'];
};

export type SiteTagsOverride = {
  __typename?: 'SiteTagsOverride';
  customerId: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export enum SortOrders {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type State = {
  __typename?: 'State';
  machineId: Scalars['String']['output'];
  receivedAt?: Maybe<Scalars['String']['output']>;
  recordedAt?: Maybe<Scalars['String']['output']>;
  stateName: Scalars['String']['output'];
  stateValue?: Maybe<Scalars['String']['output']>;
};

export enum Status {
  Active = 'active',
  Invited = 'invited',
  Unauthorized = 'unauthorized'
}

export type Subscription = {
  __typename?: 'Subscription';
  onMachineUpdate?: Maybe<MachineUpdate>;
};


export type SubscriptionOnMachineUpdateArgs = {
  customerId: Scalars['String']['input'];
  machineId: Scalars['ID']['input'];
};

export enum SupportedLanguage {
  Cs = 'CS',
  Da = 'DA',
  De = 'DE',
  En = 'EN',
  Fr = 'FR',
  It = 'IT',
  Ja = 'JA',
  Nb = 'NB',
  Nl = 'NL',
  Pl = 'PL',
  Sv = 'SV',
  ZhTw = 'ZH_TW'
}

export type Tag = {
  __typename?: 'Tag';
  customerId: Scalars['String']['output'];
  tag: Scalars['String']['output'];
};

export enum TaskCompletion {
  Completed = 'COMPLETED',
  Interrupted = 'INTERRUPTED',
  Skipped = 'SKIPPED',
  Stopped = 'STOPPED'
}

export type TimeSpan = {
  durationMs: Scalars['Int']['input'];
  plannedDurationMs: Scalars['Int']['input'];
  startHoursUtc: Scalars['Int']['input'];
  startMinutesUtc: Scalars['Int']['input'];
};

export enum Type {
  Alert = 'Alert',
  Info = 'Info'
}

export type User = {
  __typename?: 'User';
  createdAt: Scalars['AWSDateTime']['output'];
  customerId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  role: Role;
  status?: Maybe<Status>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum UserRole {
  CustomerAdmin = 'CUSTOMER_ADMIN',
  CustomerStrategicManager = 'CUSTOMER_STRATEGIC_MANAGER'
}

export type WorkInterval = {
  __typename?: 'WorkInterval';
  createdAt: Scalars['AWSDateTime']['output'];
  customerId: Scalars['String']['output'];
  durationMs: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  machine: Machine;
  plannedDurationMs?: Maybe<Scalars['Int']['output']>;
  recurring: RecurrenceInterval;
  startHoursUtc: Scalars['Int']['output'];
  startMinutesUtc: Scalars['Int']['output'];
  weekdaysUtc: Array<Scalars['Int']['output']>;
};
